import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import Button from "./layout/button";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "block",

  },
  imgwrapper: {
    textAlign: "center",
  },
}));

export default function Leistung(props) {
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.wrapper} id="leistungen">
      <Grid className={classes.imgwrapper}>
        <img src={props.icon} alt={props.header} />
        </Grid>
        <h5>{props.header}</h5>
        <p className="margin__none">{props.text}</p>
        {props.slug && <Button link={props.slug} text="Mehr" />}
      </Grid>
    </>
  );
}
